import React, { useState } from "react";
import { Image } from "antd";

const CreativeImage = ({ src, alt = "Creative Image", style, fallbackText = "Creative Image" }) => {
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setHasError(true);
  };

  if (hasError) {
    return (
      <div
        style={{
          width: "100px",
          height: "50px",
          backgroundColor: "gray",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontSize: "12px",
          ...style,
        }}
      >
        {fallbackText}
      </div>
    );
  }

  return (
    <Image
      alt={alt}
      src={src}
      style={style}
      onError={handleError}
    />
  );
};

export default CreativeImage;